/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpEndpointsList } from "../funcs/mcpEndpointsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListMcpEndpointsResult } from "../models/components/listmcpendpointsresult.js";
import {
  ListMcpEndpointsRequest,
  ListMcpEndpointsSecurity,
} from "../models/operations/listmcpendpoints.js";
import { unwrapAsync } from "../types/fp.js";
export type McpEndpointsQueryData = ListMcpEndpointsResult;

export function prefetchMcpEndpoints(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListMcpEndpointsRequest | undefined,
  security?: ListMcpEndpointsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildMcpEndpointsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildMcpEndpointsQuery(
  client$: GramCore,
  request?: ListMcpEndpointsRequest | undefined,
  security?: ListMcpEndpointsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<McpEndpointsQueryData>;
} {
  return {
    queryKey: queryKeyMcpEndpoints({
      mcpServerId: request?.mcpServerId,
      metaMcpServerId: request?.metaMcpServerId,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function mcpEndpointsQueryFn(
      ctx,
    ): Promise<McpEndpointsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpEndpointsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyMcpEndpoints(
  parameters: {
    mcpServerId?: string | undefined;
    metaMcpServerId?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpEndpoints", "list", parameters];
}
